import React from "react";
import {FileDropper} from "../../../utils/interaction/draganddrop/FileDropper";
import {WarningWindowV5} from "../popup/WarningWindowV5";

interface IFileDropperWrapperProps {
	readonly accept: string;
	readonly children: React.ReactElement;
	readonly onFileInputChange: (files: FileList) => void;
}

export class FileDropperWrapperV5 extends React.Component<IFileDropperWrapperProps> {
	private _dropper: FileDropper;
	private readonly _containerRef = React.createRef<HTMLDivElement>();

	private readonly onDragOver = (event: DragEvent) => {
		return true;
	};

	private async onFileChange(files: FileList) {
		if (this._dropper.checkType(files)) {
			this.props.onFileInputChange(files);
		} else {
			await WarningWindowV5.open(`Wrong filetype! Only the following types are accepted: ${this.props.accept}`);
		}

		this.forceUpdate();
	}

	private readonly onDrop = (event: DragEvent) => {
		this.onFileChange(event.dataTransfer.files);
	};

	public override componentDidMount() {
		this._dropper = new FileDropper({
			targetElement: this._containerRef.current?.children[0],
			onDragOver: this.onDragOver,
			onDrop: this.onDrop,
			accept: this.props.accept,
		});
	}

	public override componentWillUnmount() {
		if (this._dropper) {
			this._dropper.disable();
		}
	}

	public override render() {
		return (
			<div
				ref={this._containerRef}
				style={{display: "contents"}}
			>
				{this.props.children}
			</div>
		);
	}
}
